import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import AuthPage from "./pages/AuthPage";
import Checkout from "./pages/Checkout";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import Admin from "./pages/Admin";
import AdminOrder from "./pages/AdminOrder";
import Account from "./pages/Account";
import { ForgotPassword, ResetPassword } from "./pages/AuthExtras";
import CookieBanner from "./components/CookieBanner";
import ChatWidget from "./components/ChatWidget";
import ErrorBoundary from "./components/ErrorBoundary";
import { PrivacyPolicy, CookiePolicy, Terms, ShippingPage, ReturnsPolicyPage, AboutPage, NoteLegaliPage } from "./pages/LegalPages";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Navbar />
            <CartDrawer />
            <ErrorBoundary>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/prodotto/:id" element={<ProductDetail />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/ordini/:id" element={<AdminOrder />} />
              <Route path="/account/:tab?" element={<Account />} />
              <Route path="/password-dimenticata" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/condizioni" element={<Terms />} />
              <Route path="/spedizioni" element={<ShippingPage />} />
              <Route path="/resi" element={<ReturnsPolicyPage />} />
              <Route path="/note-legali" element={<NoteLegaliPage />} />
              <Route path="/chi-siamo" element={<AboutPage />} />
            </Routes>
            </ErrorBoundary>
            <CookieBanner />
            <ChatWidget />
            <Toaster position="bottom-left" theme="dark" />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
